

import { getPriorityConfig, getPriorityConfigById, Priority } from '@/Enums/Priority';
import { defineComponent} from 'vue';

export default defineComponent({
	name: "priority-chip",
	props: {
		priorityId: {
			type: Number,
			required: true,
			default: 3,
		},
		allowChanging: {
			type: Boolean,
			required: false,
			default: true,
		}
	},
	emits: {
		// the parent component is responsible for listening and updating the priority when this event
		// is emitted. The new value will be the PriorityId of the new Priority
		newPrioritySelected: (payload: number) => typeof payload === 'number'
	},
	data: () => ({
		allPriorityConfigs: Object.values(Priority)
								.filter(val => typeof val !== "string")
								.map(val => getPriorityConfig(val as Priority))
	}),
	methods: {
		setPriority(p: number): void {
			this.$emit("newPrioritySelected", p)
		}
	},
	computed: {
		priority() {
			return getPriorityConfigById(this.priorityId)
		}
	}
})
